import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Palette {
    tableHeaderColors: Palette['primary'];
  }

  interface PaletteOptions {
    tableHeaderColors?: PaletteOptions['primary'];
  }

  interface PaletteColor {
    lightest?: string;
  }

  interface SimplePaletteColorOptions {
    lightest?: string;
  }
}

let customTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      // Matches the "AI" blue from the PrismAI wordmark (prismai-logo.svg),
      // rather than the green used elsewhere in the Prism product family.
      main: '#0E3DA4',
      light: "#3E63B6",
      dark: "#0A2D7B",
      lightest: "#DAE1F1"
    },
    tableHeaderColors: {
      main: '#809CAB',
      light: '#fff',
    },
  },
  typography: {
    fontFamily: "Poppins, sans-serif"
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          overflow: 'auto',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          fontSize: 14,
          fontWeight: 'bold',
        },
      },
    }
  },
});

customTheme = createTheme(customTheme, {
  components: {
     MuiButton: {
      styleOverrides: {
        root: {
          // Targets the built-in MUI disabled state class
          '&.Mui-disabled': {
            backgroundColor: customTheme.palette.primary.lightest,
            color: '#FFFFFF',
          },
        },
      }
    }
  },
});

export default customTheme;
